import Icon from '@components/officialTopupNew/common/Icon.vue';
import Select from '@components/officialTopupNew/common/Select.vue';
import Button from '@components/officialTopupNew/common/Button.vue';
import SelectGroup from '@components/officialTopupNew/common/SelectGroup.vue';
import PopupWindow from '@components/officialTopupNew/common/PopupWindow.vue';
import DataList from '@components/officialTopupNew/common/DataList.vue';
import GiftIcon from '@components/officialTopupNew/common/GiftIcon.vue';

export default {
  install(Vue) {
    Vue.component('Icon', Icon);
    Vue.component('Select', Select);
    Vue.component('Button', Button);
    Vue.component('SelectGroup', SelectGroup);
    Vue.component('PopupWindow', PopupWindow);
    Vue.component('DataList', DataList);
    Vue.component('GiftIcon', GiftIcon);
  }
};
